export const IMPACT_SCORE_DISCLAIMER =
  "Oath does not make candidate endorsements. Oath's Impact Score is updated based on the latest campaign finance, expert ratings, and other key race data. Your score may change over time.";

// The press release template and Canva folder are linked from this article, so
// the CTA only needs to point here rather than to each asset individually.
export const IMPACT_SCORE_RESOURCE_CENTER_ARTICLE_PATH =
  '/what-are-the-best-ways-to-promote-my-impact-score';
